  let userGeolocation = localStorage.getItem('userGeolocation');
const cardWrapperQuick = document.querySelector('#Product-Drawer-Content')
// Функция для скрытия недоступных вариантов
function hideUnavailableVariants(userGeolocation) {
  // Извлекаем все элементы мета-полей для США и остальных стран
  const usMetaItems = cardWrapperQuick.querySelectorAll('.meta-hide-logic-us__item');
  const restMetaItems = cardWrapperQuick.querySelectorAll('.meta-hide-logic-rest__item');

  // Находим все fieldset, внутри которых могут находиться варианты
  const fieldsets = cardWrapperQuick.querySelectorAll('fieldset.product-form__input--color, fieldset.product-form__input--block');

  if (!fieldsets.length) {
    setTimeout(() => hideUnavailableVariants(userGeolocation), 1000);
    return;
  }

  fieldsets.forEach((fieldset) => {
    usMetaItems.forEach((metaItem) => {
      const shouldHideUS = metaItem.querySelector('#meta-hide-logic-us-data').textContent === 'true';
      const variantNameUS = metaItem.querySelector('#meta-hide-logic-us-variant-name').textContent;

      if (shouldHideUS && userGeolocation === 'US') {
        hideVariantQuick(fieldset, variantNameUS);
      }
    });

    restMetaItems.forEach((metaItem) => {
      const shouldHideRest = metaItem.querySelector('#meta-hide-logic-rest-data').textContent === 'true';
      const variantNameRest = metaItem.querySelector('#meta-hide-logic-rest-variant-name').textContent;

      if (shouldHideRest && userGeolocation !== 'US') {
        hideVariantQuick(fieldset, variantNameRest);
              setTimeout(function () {
  hideVariantQuick(fieldset, variantNameRest);
      }, 500);
      }
    });
  });
}

// Функция для скрытия конкретного варианта по его названию
function hideVariantQuick(fieldset, variantName) {
  // Находим все labels внутри fieldset
  const labels = fieldset.querySelectorAll('label');
  labels.forEach((label) => {
        if (label.textContent.trim() === variantName) {
          // Скрываем label, если вариант должен быть скрыт
          label.style.display = "none";

          // Также скрываем связанный input, если это необходимо
          const input = fieldset.querySelector(`input[value="${variantName}"]`);
          if (input) {
            input.style.display = "none";
          }
        }
      
  });

  // Проверяем, остался ли только один видимый label
  const visibleLabels = Array.from(labels).filter(label => label.style.display !== 'none');
  if (visibleLabels.length === 0) {
    const addToCartButton = document.getElementById("AddToCart");
    const addToCartButtonAddon = document.getElementById("AddToCartAddons");
    const addToCartButtonSticky = document.getElementById("AddToCartSticky");
    if (addToCartButtonSticky) {
      addToCartButtonSticky.textContent = "Out of stock";
      addToCartButtonSticky.disabled = true; // Делаем кнопку неактивной
    }

        if (addToCartButtonAddon) {
      addToCartButtonAddon.textContent = "Out of stock";
      addToCartButtonAddon.disabled = true; // Делаем кнопку неактивной
    }

    if (addToCartButton) {
      addToCartButton.textContent = "Out of stock"; 
      addToCartButton.disabled = true; // Делаем кнопку неактивной 
    }
  }
}

// Функция для клика по первому видимому label
function clickFirstVisibleLabel() {
  // Находим все fieldset, внутри которых могут находиться варианты
  const fieldsets = document.querySelectorAll('fieldset.product-form__input--color, fieldset.product-form__input--block');

  if (!fieldsets.length) return;

  fieldsets.forEach((fieldset) => {
    // Ищем первый видимый label и кликаем по нему
    const visibleLabel = Array.from(fieldset.querySelectorAll('label')).find(
      (label) => label.style.display !== 'none'
    );

    if (visibleLabel) {
      setTimeout(function () {
       // visibleLabel.click();
      }, 5000);
    }
  });
}



function handleQuickViewPopup() {
  // Здесь вызываем функцию с текущей геолокацией пользователя
  const userGeolocation = localStorage.getItem('userGeolocation');
  hideUnavailableVariants(userGeolocation);
  clickFirstVisibleLabel();
}


  // Логика для обработки popup после клика
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-card-quickview').forEach((button) => {
    button.addEventListener('click', function () {
      setTimeout(function () {
        handleQuickViewPopup();
      }, 500);
    });
  });
});

function checkCartDrawerButtons() {
  const allButtonsCartDrawer = document.querySelectorAll(
    ".product-card-small--add-to-cart-button",
  );

  if (allButtonsCartDrawer.length > 0) {

    allButtonsCartDrawer.forEach((button) => {
      if (!button.dataset.listenerAttached) {
        button.dataset.listenerAttached = "true"; // Помечаем, что обработчик добавлен
        button.addEventListener("click", function () {
          setTimeout(function () {
            handleQuickViewPopup();
          }, 500);
        });
      }
    });
  } else {
    setTimeout(checkCartDrawerButtons, 500); // Пробуем снова через 500 мс
  }
}

checkCartDrawerButtons();


checkCartDrawerButtons()
const allButtonsCartDrawer = document.querySelectorAll('.product-card-small--add-to-cart-button');

// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.product-card-small--add-to-cart-button').forEach((button) => {
//     button.addEventListener('click', function () {
//       console.log("ssdsa cart-drawer")
//       setTimeout(function () {
//         handleQuickViewPopup();
//       }, 500);
//     });
//   });
// });


function removeUnavailableOptionsByMeta(userGeolocation) {
  // Ищем все элементы <product-add-to-cart-sticky>
  const stickyElements = document.querySelectorAll('product-add-to-cart-sticky');

  if (!stickyElements.length) return;

  // Получаем мета-поля для определения доступности вариантов
  const usMetaItems = document.querySelectorAll('.meta-hide-logic-us__item');
  const restMetaItems = document.querySelectorAll('.meta-hide-logic-rest__item');

  stickyElements.forEach((stickyElement) => {
    // Ищем все select внутри текущего элемента
    const selects = stickyElement.querySelectorAll('select');

    selects.forEach((select) => {
      // Проходим по каждому option
      const options = Array.from(select.options);

      options.forEach((option) => {
        const optionValue = option.value.trim(); // Имя варианта

        // Проверяем доступность варианта для текущей геолокации
        const shouldHide = checkOptionAvailability(optionValue, userGeolocation, usMetaItems, restMetaItems);

        if (shouldHide) {
          // Удаляем недоступный вариант
          option.remove();
        }
      });

      // Если после удаления не осталось доступных вариантов
      if (select.options.length === 0) {
        const addToCartButton = document.getElementById('AddToCartSticky');
        if (addToCartButton) {
          addToCartButton.textContent = 'Out of stock';
          addToCartButton.disabled = true;
        }
      }
    });
  });
}

// Функция проверки доступности варианта
function checkOptionAvailability(optionValue, userGeolocation, usMetaItems, restMetaItems) {
  let isUnavailable = false;

  if (userGeolocation === 'US') {
    usMetaItems.forEach((metaItem) => {
      const shouldHideUS = metaItem.querySelector('#meta-hide-logic-us-data').textContent === 'true';
      const variantNameUS = metaItem.querySelector('#meta-hide-logic-us-variant-name').textContent;

      if (shouldHideUS && variantNameUS.trim() === optionValue) {
        isUnavailable = true;
      }
    });
  } else {
    restMetaItems.forEach((metaItem) => {
      const shouldHideRest = metaItem.querySelector('#meta-hide-logic-rest-data').textContent === 'true';
      const variantNameRest = metaItem.querySelector('#meta-hide-logic-rest-variant-name').textContent;

      if (shouldHideRest && variantNameRest.trim() === optionValue) {
        isUnavailable = true;
      }
    });
  }

  return isUnavailable;
}
